import React,{useContext} from 'react';
import { EventContext } from '../../App';

const SantaImage = ({eventData}) => {
  const {haveEventData} = useContext(EventContext)

  return (
   <>
       <>
       <div className="homeEvent-container">
         <img
           className="homeEvent-img"
           src={`/assets/loaderImg/santa.png`}
           alt="Hanging Images For Conative Loader"
         />
       </div>
       </>
   </>
  );
};

export default SantaImage;
